const selectors = {
  triggerBtn: "#choose-lenses",
  closeBtn: "#popup-close",
  popupWrapper: ".choose-lenses-wrapper",
  body: "body",
  goBackBtn: "#popup-goback",
  navItems: ".choose-lenses-nav-item",
  galleryMedia: ".product-gallery__thumbnail",
  popupMedia: ".choose-lenses-main-product img",
  chooseColour: ".choose-colour",
  readMoreeEls: "[data-readmore-content]",
  subtotalContainer: ".subtotal-container",
  subtotalProductImage: ".choose-lenses-subtotal-products img",
  subtotalPrice: ".choose-lenses-total-price .price",
  stepsPrice: ".subtotal-container-total .price",
  colorsWrapper: ".colors-wrapper",
  colorEl: ".color-el",
  chooseLensesEdit: ".choose-lenses-edit",
  extraProduct: ".extra-product",
  errorMsg: ".error-cart-msg",
  mainProductId: "input[name='id']",
  mainProductQuantity: ".choose-lenses-total-quantity input",
  additionalPopupWrapper: ".additional-popup-wrapper",
  additionalPopupContainer: ".additional-popup-container",
  popupAtcBtn: ".atc-next-step",
  popupCheckoutBtn: ".popup-checkout-btn",
  steps: ".choose-lenses-step",
  step_1: "#step-1",
};

const colorMap = {
  Grey: "#b7b7b7",
  Brown: "#8f845f",
  Green: "#717f74",
};

const $ = (selector) => document.querySelector(selector);
const $$ = (selector) => document.querySelectorAll(selector);

const triggerBtn = $(selectors.triggerBtn);
const closeBtn = $(selectors.closeBtn);
const popupWrapper = $(selectors.popupWrapper);
const body = $(selectors.body);
const goBackBtn = $(selectors.goBackBtn);
const additionalPopupWrapper = $(selectors.additionalPopupWrapper);
const additionalPopupContainer = $(selectors.additionalPopupContainer);
const popupAtcBtn = $(selectors.popupAtcBtn);
const popupMedia = $(selectors.popupMedia);
const subtotalContainer = $(selectors.subtotalContainer);
const step_1 = $(selectors.step_1);
const popupCheckoutBtn = $(selectors.popupCheckoutBtn);
const mainProductId = $(selectors.mainProductId);
const mainProductQuantity = $(selectors.mainProductQuantity);
const subtotalProductImage = $(selectors.subtotalProductImage);
const errorMsg = $(selectors.errorMsg);
const subtotalPrice = $(selectors.subtotalPrice);
const stepsPrice = $(selectors.stepsPrice);

const chooseLensesEdit = $$(selectors.chooseLensesEdit);
const extraProduct = $$(selectors.extraProduct);
const readMoreeEls = $$(selectors.readMoreeEls);
const chooseColour = $$(selectors.chooseColour);
const steps = $$(selectors.steps);
const navItems = $$(selectors.navItems);
const galleryMedia = $$(selectors.galleryMedia);

let formData = [];
const selectedExtras = [];
const mainPrice = Number(popupWrapper?.dataset.productPrice || 0);



triggerBtn?.addEventListener("click", () => {
  let mainMedia = "";

  // Try to get the selected variant's image directly
  if (window.product && window.product.variants && window.currentVariantId) {
    let selectedVariant = window.product.variants.find(v => v.id == window.currentVariantId);
    if (selectedVariant && selectedVariant.featured_image) {
      mainMedia = new Image();
      mainMedia.src = selectedVariant.featured_image.src;
      mainMedia.alt = selectedVariant.featured_image.alt || "";
    }
  }

  // Fallback to existing method if variant image not found
  if (!mainMedia) {
    galleryMedia.forEach((el) => {
      if (el.style.display != "none" && !mainMedia) {
        mainMedia = el.querySelector("img");
      }
    });
  }

  popupMedia.src = mainMedia.src;
  popupMedia.alt = mainMedia.alt;
  subtotalProductImage.src = mainMedia.src;
  subtotalProductImage.alt = mainMedia.alt;

  popupWrapper.style.display = "block";
  body.style.overflow = "hidden";
});

closeBtn?.addEventListener("click", () => {
  popupWrapper.style.display = "none";
  body.style.overflow = "unset";
});
function updateBackButton(nextStep = null) {
  const activeNavItems = $$(selectors.navItems);
  const allSteps = $$(selectors.steps);

  if (nextStep) {
    activeNavItems.forEach((item, index) => {
      item.classList.toggle("active", index < +nextStep);
    });

    allSteps.forEach((step) => {
      step.classList.toggle("active", step.id === `step-${nextStep}`);
    });
  }

  const activeCount = document.querySelectorAll(
    ".choose-lenses-nav-item.active"
  ).length;

  if (activeCount === 1) {
    formData = [];
    extraProduct.forEach((el) => {
      el.querySelector("input").checked = false;
    });
  }
  if (activeCount === 3) {
    extraProduct.forEach((el) => {
      el.querySelector("input").checked = false;
    });
  }

  if (activeCount === 4) {
    popupAtcBtn.textContent = "Skip";
  }
  if (activeCount === 5) {
    popupAtcBtn.textContent = "Add to cart";
  }
  goBackBtn.classList.toggle("active", activeCount > 1);
  subtotalContainer.classList.toggle("active", activeCount > 1);
  popupAtcBtn.classList.toggle("active", activeCount > 3);
  subtotalContainer.classList.toggle("active_summary", activeCount > 4);
}

function displayFormData() {
  const summaryEls = document.querySelectorAll(
    ".choose-lenses-subtotal-info-el"
  );

  summaryEls.forEach((el) => {
    el.style.display = "none";
  });

  formData.forEach((entry) => {
    const key = Object.keys(entry)[0];
    const data = entry[key];

    summaryEls.forEach((el) => {
      const label = el.querySelector("p > b");
      const span = el.querySelector("p > span");

      if (!label || !span) return;

      const labelText = label.textContent.trim().replace(":", "").toLowerCase();
      const keyText = key.trim().toLowerCase();

      if (labelText.includes("extra") && keyText.includes("extra")) {
        if (Array.isArray(data.extras) && data.extras.length > 0) {
          const extrasTitles = data.extras
            .map((extra) => extra.title)
            .join(", ");

          span.textContent = extrasTitles;
          el.style.display = "";
        }
      } else if (labelText === keyText) {
        if (data.title) {
          span.textContent = data.title;
          el.style.display = "";
        }
      }
    });
  });
}

function getMappedColor(colorName) {
  const key = Object.keys(colorMap).find(
    (k) => k.toLowerCase() === colorName.trim().toLowerCase()
  );
  return key ? colorMap[key] : colorName.trim();
}
function selectColor(el, parentWrapper) {
  let variant_id = +el.dataset.variantId;
  const colorEl = $$(selectors.colorEl);
  const colorsWrapper = $(selectors.colorsWrapper);
  let parentEl = parentWrapper.previousElementSibling;

  colorEl.forEach((el) => {
    if (+el.dataset.variantId === variant_id) {
      el.querySelector("span").style.border = "3px solid white";
      el.querySelector("span").style.boxShadow = `0 0 0 3px ${getMappedColor(
        el.textContent
      )}`;
      colorsWrapper.querySelector(
        "p"
      ).innerHTML = `You selected <em>${el.textContent.toUpperCase()}</em> color`;
      colorsWrapper.querySelector("button").style.display = "block";
      colorsWrapper.querySelector("button").addEventListener("click", () => {
        additionalPopupWrapper.style.display = "none";
        parentEl.dataset.variantId = el.dataset.variantId;
        parentEl.dataset.price = el.dataset.price;
        parentEl.querySelector(
          ".choose-lenses-step-item-title span"
        ).textContent = ` - ${el.textContent}`;
        parentEl.click();
      });
    } else {
      el.querySelector("span").style.border = "unset";
      el.querySelector("span").style.boxShadow = "unset";
    }
  });
}
function initializeAdditionalPopup(el, type) {
  if (type === "readmore") {
    additionalPopupWrapper.style.display = "flex";
    additionalPopupContainer.innerHTML = el.dataset.readmoreContent;
  } else if (type === "color") {
    additionalPopupWrapper.style.display = "flex";
    let variantInfo = JSON.parse(el.dataset.variantsInfo);
    let stepTitle = el.dataset.stepTitle.toLowerCase();
    let colorsContent = document.createElement("div");
    colorsContent.innerHTML = `  
  <div class="colors-wrapper">
    <span class="colors-title">Choose your ${stepTitle} color</span>
    <div class="colors-els">
      ${variantInfo
        .map(
          (variant) => `
          <div 
            class="color-el" 
            data-variant-id="${variant.id}" 
            data-color="${variant.title}"
            data-price="${variant.price}"
            style="cursor:pointer"
          >
            <span style="background-color:${getMappedColor(
              variant.title
            )};"></span>
            ${variant.title}
          </div>
        `
        )
        .join("")}
    </div>
    <p></p>
    <button style="display:none">Continue</button>
  </div>`;
    additionalPopupContainer.innerHTML = colorsContent.innerHTML;

    const colorEl = $$(selectors.colorEl);
    colorEl.forEach((colorEl) => {
      colorEl.addEventListener("click", () => {
        selectColor(colorEl, el);
      });
    });
  }
  additionalPopupWrapper.addEventListener("click", (el) => {
    if (
      el.target.classList.contains("additional-popup-wrapper") ||
      el.target.classList.contains("close-btn")
    ) {
      additionalPopupWrapper.style.display = "none";
      additionalPopupContainer.innerHTML = "";
    }
  });
}

function recalculateSubtotal() {
  let mainPrice = 0;
  let additionalTotal = 0;

  const productWrapper = document.querySelector(".choose-lenses-wrapper");
  const defaultMainPrice = Number(productWrapper?.dataset.productPrice || 0);

  formData.forEach((step) => {
    const key = Object.keys(step)[0];
    if (key.toLowerCase().includes("extra")) return;

    const data = step[key];
    const price = Number(data.price || 0);
    const priceType = data.priceType;

    if (priceType === "main" && data.choused_on_step === "1") {
      mainPrice = price;
    } else if (priceType === "additional") {
      additionalTotal += price;
    }
  });

  if (mainPrice === 0 && defaultMainPrice > 0) {
    mainPrice = defaultMainPrice;
  }

  const selected = [];
  extraProduct.forEach((el) => {
    const input = el.querySelector("input:checked");
    if (input) {
      selected.push({
        id: input.id,
        title: el.querySelector(".extra-product-info p").textContent.trim(),
        price: +input.dataset.price,
      });
    }
  });

  if (selected.length > 0) {
    popupAtcBtn.textContent = "Add to cart";
  } else {
    popupAtcBtn.textContent = "Skip";
  }

  const extrasTotal = selected.reduce((sum, item) => sum + item.price, 0);
  const quantity = parseInt(mainProductQuantity.value) || 1;

  const subtotal = mainPrice * quantity + additionalTotal + extrasTotal;

  formData = formData.filter(
    (entry) => Object.keys(entry)[0] !== "Extra products"
  );
  if (selected.length) {
    formData.push({
      "Extra products": {
        choused_on_step: "4",
        extras: selected,
      },
    });
  }

  subtotalPrice.textContent = `${(subtotal / 100).toFixed(2)}`;
  stepsPrice.textContent = `${(subtotal / 100).toFixed(2)}`;
  subtotalPrice.dataset.originalPrice = subtotal;
  stepsPrice.dataset.originalPrice = subtotal;
}

function collectFormData(
  currentStep,
  stepTitle,
  price,
  priceType,
  title,
  lineProperties = null,
  variantId = null
) {
  formData = formData.filter((entry) => {
    const key = Object.keys(entry)[0];
    const data = entry[key];
    return data.choused_on_step !== currentStep;
  });

  const stepInfo = {
    [lineProperties ? "line_properties" : "variant_id"]:
      lineProperties || variantId,
    choused_on_step: currentStep,
    price: +price,
    priceType,
    title,
  };

  formData.push({
    [stepTitle]: stepInfo,
  });

  recalculateSubtotal();
}

function addToCart(redirectUrl = "/cart") {
  const mainId = mainProductId.value;
  const quantity = parseInt(mainProductQuantity.value) || 1;

  const items = [];
  const properties = {};

  formData.forEach((entry) => {
    const key = Object.keys(entry)[0];
    const data = entry[key];

    if (data.title != "Non-Prescription ") {
      properties["_prescriptionDetails"] = "Prescription";
    }
    if (data.variant_id) {
      items.push({
        id: data.variant_id,
        quantity: 1,
      });
    } else if (data.title) {
      properties[key] = data.title;
    } else if (Array.isArray(data.extras)) {
      data.extras
        .filter((extra) => extra.available !== false)
        .forEach((extra) => {
          items.push({
            id: extra.id,
            quantity: 1,
          });
        });
    }
  });

  const mainItem = {
    id: mainId,
    quantity: quantity,
  };

  if (Object.keys(properties).length > 0) {
    mainItem.properties = properties;
  }

  items.unshift(mainItem);

  fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ items }),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Failed to add to cart");
      }
      return response.json();
    })
    .then((cart) => {
      extraProduct.forEach((el) => {
        el.querySelector("input").checked = false;
      });
      mainProductQuantity.value = 1;
      if (redirectUrl) window.location.href = redirectUrl;
    })
    .catch((err) => {
      errorMsg.style.display = "block";
      errorMsg.textContent = err;
      console.error("❌ Cart error:", err);
    });
}
goBackBtn?.addEventListener("click", () => {
  const activeNavItems = $$(selectors.navItems + ".active");
  const currentStep = $(".choose-lenses-step.active");

  if (!currentStep) return;

  const currentStepNumber = currentStep.id.split("-")[1];

  formData = formData.filter((entry) => {
    const stepKey = Object.keys(entry)[0];
    return entry[stepKey].choused_on_step !== currentStepNumber;
  });

  recalculateSubtotal();

  if (formData.length === 1) {
    activeNavItems.forEach((el) => {
      el.classList.remove("active");
    });
    activeNavItems[1].classList.add("active");
    steps.forEach((el) => {
      el.classList.remove("active");
    });
    steps[0].classList.add("active");
  } else {
    if (activeNavItems.length > 1) {
      activeNavItems[activeNavItems.length - 1].classList.remove("active");
    }

    const currentIndex = Array.from(steps).indexOf(currentStep);
    if (currentIndex > 0) {
      currentStep.classList.remove("active");
      steps[currentIndex - 1].classList.add("active");
    }
  }

  errorMsg.style.display = "none";
  errorMsg.textContent = "";

  updateBackButton();
});

steps?.forEach((el) => {
  let stepTitle = el?.querySelector(".product-title span")?.textContent;
  let currentStep = el.id.split("-")[1];

  el.querySelectorAll(".choose-lenses-step-item").forEach((step) => {
    step.addEventListener("click", (e) => {
      if (!e.target.classList.contains("choose-lenses-step-readmore")) {
        const target = e.currentTarget;
        const nextStep = target.dataset.nextStep;
        const lineProperties = target.dataset.lineProperties;
        const variantId = target.dataset.variantId;
        const price = target.dataset.price;
        const priceType = target.dataset.priceType;
        const title = target.querySelector("span").textContent;

        collectFormData(
          currentStep,
          stepTitle,
          price,
          priceType,
          title,
          lineProperties,
          variantId
        );
        updateBackButton(nextStep);
        recalculateSubtotal();
      }
    });
  });
});

readMoreeEls.forEach((el) => {
  el.addEventListener("click", (el) =>
    initializeAdditionalPopup(el.currentTarget, "readmore")
  );
});
chooseColour.forEach((el) => {
  el.addEventListener("click", (el) =>
    initializeAdditionalPopup(el.currentTarget, "color")
  );
});
chooseLensesEdit.forEach((el, index) => {
  el.addEventListener("click", () => updateBackButton(index + 1));
});
extraProduct.forEach((el) => {
  const input = el.querySelector("input");
  input.addEventListener("change", () => {
    recalculateSubtotal();
  });
});

mainProductQuantity.addEventListener("change", (input) => {
  if (+input.target.value <= 0) {
    input.target.value = 1;
  }
  recalculateSubtotal();
});

popupAtcBtn.addEventListener("click", () => {
  if (!subtotalContainer.classList.contains("active_summary")) {
    const selectedExtras = [];

    extraProduct.forEach((el) => {
      const input = el.querySelector("input:checked");
      if (input) {
        selectedExtras.push({
          id: input.id,
          title: el.querySelector(".extra-product-info p").textContent.trim(),
          price: +input.dataset.price,
        });
      }
    });

    const extraIndex = formData.findIndex(
      (entry) => Object.keys(entry)[0] === "Extra products"
    );

    if (extraIndex !== -1) {
      if (selectedExtras.length) {
        formData[extraIndex]["Extra products"].extras = selectedExtras;
      } else {
        formData.splice(extraIndex, 1);
      }
    } else if (selectedExtras.length) {
      formData.push({
        "Extra products": {
          choused_on_step: "4",
          extras: selectedExtras,
        },
      });
    }

    updateBackButton(5);
    displayFormData();
  } else {
    addToCart();
  }
});
popupCheckoutBtn.addEventListener("click", () => {
  addToCart("/checkout");
});
